import LegalLayout from './LegalLayout';

export default function NdaPage() {
  return (
    <LegalLayout
      title="Non-Disclosure Agreement"
      updated="May 2026"
      testId="nda-page"
      notice={
        <>
          This Non-Disclosure Agreement protects private business information, identities, locations,
          access details, communications, operational procedures, and other confidential information
          associated with Casa de Candy.
        </>
      }
    >
      <div className="legal-section">
        <h2>1. Agreement to Confidentiality</h2>
        <p>
          By accessing Casa de Candy websites, clicking through any consent flow, submitting
          information, communicating by SMS, WhatsApp, phone, email, form, or online message, receiving
          location or access details, requesting an appointment, booking an appointment, visiting any
          location, or interacting with Casa de Candy personnel, contractors, hosts, or representatives,
          you agree to maintain strict confidentiality regarding all Confidential Information.
        </p>
      </div>

      <div className="legal-section">
        <h2>2. Confidential Information Defined</h2>
        <p>
          “Confidential Information” includes all non-public information related to Casa de Candy,
          whether communicated verbally, visually, digitally, physically, or by implication, including
          but not limited to:
        </p>
        <ul>
          <li>
            Names, aliases, identities, images, voices, contact information, schedules, or identifying
            details of owners, personnel, contractors, hosts, clients, visitors, vendors, or affiliates;
          </li>
          <li>
            Physical addresses, directions, maps, pin drops, cross streets, parking instructions, entry
            instructions, gate codes, building descriptions, routes, security details, proximity
            screenshots, or access procedures;
          </li>
          <li>
            SMS messages, WhatsApp messages, phone calls, emails, forms, screenshots, booking details,
            appointment details, customer-service communications, private links, website flows, or
            internal instructions;
          </li>
          <li>
            Pricing structures, payment methods, deposits, appointment procedures, screening practices,
            scripts, policies, operational methods, business systems, marketing strategies, and
            customer-management practices;
          </li>
          <li>
            Photos, videos, audio, décor, layouts, private areas, ambiance, equipment, signage,
            vehicles, operational patterns, schedules, staffing arrangements, or other visual or
            descriptive details not publicly released by Casa de Candy;
          </li>
          <li>
            Any information that a reasonable person would understand to be private, discreet,
            sensitive, operational, or confidential based on the nature of the interaction.
          </li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>3. Confidentiality Obligations</h2>
        <p>You agree to:</p>
        <ul>
          <li>Keep all Confidential Information strictly private;</li>
          <li>Use Confidential Information only for the limited purpose for which it was provided;</li>
          <li>Not disclose, publish, forward, leak, sell, trade, expose, copy, distribute, or misuse Confidential Information;</li>
          <li>Take reasonable steps to prevent unauthorized access to Confidential Information in your possession;</li>
          <li>Immediately delete or return Confidential Information upon request where reasonably possible.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>4. Prohibited Conduct</h2>
        <p>You may not directly or indirectly:</p>
        <ul>
          <li>Take photos, videos, screenshots, screen recordings, livestreams, or audio recordings without prior written permission;</li>
          <li>Share, post, publish, forward, or distribute private messages, private links, booking details, access details, or appointment information;</li>
          <li>Reveal locations, directions, cross streets, parking details, access codes, staff identities, client identities, host identities, or operational details;</li>
          <li>Create public posts, comments, reviews, reports, or statements that disclose private, identifying, confidential, or operational information;</li>
          <li>Use Confidential Information to harass, threaten, intimidate, stalk, embarrass, defame, exploit, dox, investigate, surveil, interfere with, or harm Casa de Candy or any associated person;</li>
          <li>Attempt to bypass, test, expose, or interfere with Casa de Candy’s screening, privacy, security, communication, or access-control procedures;</li>
          <li>Provide Confidential Information to competitors, third-party platforms, unauthorized persons, social media pages, forums, review sites, or public groups.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>5. Permitted Use</h2>
        <p>
          Confidential Information may be used only for the limited purpose of completing the specific
          communication, inquiry, appointment coordination, or interaction for which it was provided. No
          ownership, license, right to copy, right to publish, or continuing right to use Confidential
          Information is granted.
        </p>
      </div>

      <div className="legal-section">
        <h2>6. Public Reviews and Legal Limits</h2>
        <p>
          This NDA is intended to protect confidential, private, identifying, and operational
          information. It is not intended to prohibit lawful, truthful, non-confidential opinions where
          such speech is protected by law. However, any public statement, review, post, or comment may
          not include Confidential Information, private locations, identifying details, screenshots,
          recordings, access instructions, false statements, threats, harassment, doxxing, or unlawful
          content.
        </p>
      </div>

      <div className="legal-section">
        <h2>7. Duration</h2>
        <p>
          Your confidentiality obligations begin immediately upon access to any Confidential Information
          and continue indefinitely, including after communication ends, after an appointment ends,
          after access is denied, after a user is blocked, or after any business relationship concludes.
        </p>
      </div>

      <div className="legal-section">
        <h2>8. Deletion, Return, and Preservation</h2>
        <p>
          Upon request, you agree to delete, return, remove, or destroy Confidential Information in
          your possession, including screenshots, saved messages, photos, videos, audio recordings,
          notes, private links, access details, location details, or copied materials.
        </p>
        <p>
          Casa de Candy reserves the right to preserve evidence of violations, including communications,
          screenshots, metadata, logs, payment records, platform records, and witness information.
        </p>
      </div>

      <div className="legal-section">
        <h2>9. Breach and Enforcement</h2>
        <p>
          You acknowledge that unauthorized disclosure or misuse of Confidential Information may cause
          immediate and irreparable harm. Casa de Candy reserves the right to pursue all available
          remedies, including refusal of service, termination of communication, blocking, banning,
          preservation of evidence, injunctive relief, damages, attorney’s fees where permitted by law,
          and other legal remedies.
        </p>
      </div>

      <div className="legal-section">
        <h2>10. Safety, Emergency, and Legal Exceptions</h2>
        <p>
          Nothing in this NDA prevents lawful reporting to appropriate authorities where required or
          protected by law. Nothing in this NDA prevents a person from seeking emergency assistance,
          reporting a genuine safety concern, complying with a valid court order, or exercising rights
          that cannot legally be waived.
        </p>
        <p>
          However, this NDA prohibits unnecessary public exposure, doxxing, harassment, recording,
          disclosure, distribution, or publication of Confidential Information beyond what is legally
          required or protected.
        </p>
      </div>

      <div className="legal-section">
        <h2>11. No Waiver of Rights</h2>
        <p>
          Failure by Casa de Candy to enforce any provision immediately does not waive the right to
          enforce that provision later. Any waiver must be in writing and signed by an authorized
          representative of Casa de Candy.
        </p>
      </div>

      <div className="legal-section">
        <h2>12. Relationship to Terms of Service</h2>
        <p>
          This NDA is incorporated into the Casa de Candy Terms of Service. A violation of this NDA is
          also a violation of the Terms of Service and may result in denial of service, cancellation of
          appointments, blocking, banning, or legal action where appropriate.
        </p>
      </div>

      <div className="legal-section">
        <h2>13. Governing Law</h2>
        <p>
          To the extent permitted by law, this NDA is governed by the laws of the State of Texas,
          without regard to conflict-of-law rules. Venue for court proceedings, where applicable and not
          otherwise prohibited by law, shall be in the state or federal courts located in Texas.
        </p>
      </div>

      <div className="legal-section">
        <h2>14. Severability</h2>
        <p>
          If any portion of this NDA is found invalid, unlawful, or unenforceable, the remaining
          provisions remain effective. Any invalid provision shall be modified to the minimum extent
          necessary to make it enforceable where permitted by law.
        </p>
      </div>

      <div className="legal-section">
        <h2>15. Contact</h2>
        <p>For questions about this NDA, contact: support@casadecandy.com.</p>
      </div>
    </LegalLayout>
  );
}
